<template>
  <div class="business-page">
    <div class="main-content">
      <!-- 第一部分：英雄区域 -->
      <section class="hero-section">
        <div class="container">
          <AppHeader />
          
          <div class="hero-content animate">
            <h1 class="hero-title">大型企业诉讼案管服务</h1>
            <h2 class="hero-subtitle">精准匹配 · 专业管理 · 结果导向</h2>
          </div>
        </div>
      </section>
      
      <!-- 第二部分：服务介绍 -->
      <section class="service-intro-section" ref="serviceIntroSection">
        <div class="container">
          <div class="intro-text animate-scroll">
            <p>闻讼凭借全国律师资源网络与智能化案管体系，为500强企业及全国性经营头部企业提供高效、精准的诉讼争议解决方案。我们通过数据驱动匹配、全流程服务协同、案件复盘优化，确保企业在各地的诉讼案件由经验适配、地域熟悉、专业对口的优秀律师承办，最大化实现案件最优解。</p>
          </div>
          
          <div class="service-advantages">
            <h2 class="section-title animate-scroll">服务优势</h2>
            
            <div class="advantage-list">
              <div class="advantage-item animate-scroll" style="animation-delay: 0.1s;">
                <div class="advantage-icon">
                  <img src="@/assets/image/business/matching_icon.png" alt="全国律师精准匹配">
                </div>
                <div class="advantage-content">
                  <h3 class="advantage-title">全国律师精准匹配</h3>
                  <p class="advantage-desc">覆盖各省市优质律师资源，结合案件类型、地域特点、律师专长智能推荐</p>
                </div>
              </div>
              
              <div class="advantage-item animate-scroll" style="animation-delay: 0.2s;">
                <div class="advantage-icon">
                  <img src="@/assets/image/business/management_icon.png" alt="全流程案件管理">
                </div>
                <div class="advantage-content">
                  <h3 class="advantage-title">全流程案件管理</h3>
                  <p class="advantage-desc">从立案到执行，专业团队全程跟踪，确保服务质量和进度可控</p>
                </div>
              </div>
              
              <div class="advantage-item animate-scroll" style="animation-delay: 0.3s;">
                <div class="advantage-icon">
                  <img src="@/assets/image/business/analysis_icon.png" alt="数据化复盘优化">
                </div>
                <div class="advantage-content">
                  <h3 class="advantage-title">数据化复盘优化</h3>
                  <p class="advantage-desc">结案后深度分析，反哺企业法务策略，减少同类诉讼风险</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 第三部分：服务结构 -->
      <section class="service-structure-section" ref="serviceStructureSection">
        <div class="container">
          <h2 class="section-title animate-scroll">诉讼案管服务结构</h2>
          
          <div class="structure-diagram animate-scroll">
            <!-- 企业部分 -->
            <div class="entity-box enterprise-box">
              <div class="entity-icon">
                <img src="@/assets/image/business/enterprise_icon.png" alt="企业">
              </div>
              <!-- <div class="entity-name">企业</div> -->
            </div>
            
            <!-- 企业流程 -->
            <div class="process-flow enterprise-flow">
              <div class="process-step">案件管理需求发起</div>
              <div class="arrow-down">
                <img src="@/assets/image/business/right_arrow.png" alt="箭头">
              </div>
              <div class="process-step">依企业要求 交互协同</div>
              <div class="arrow-down">
                <img src="@/assets/image/business/left_arrow.png" alt="箭头">
              </div>
              <div class="process-step">结果达成、复盘提升</div>
            </div>
            
            <!-- 案管团队 -->
            <div class="management-team">
              <div class="team-icon">
                <img src="@/assets/image/business/team_icon.png" alt="案管团队">
              </div>
              <!-- <div class="team-name">案管团队</div> -->
            </div>
            
            <!-- 律师流程 -->
            <div class="process-flow lawyer-flow">
              <div class="process-step">谋定策略+属地遴选律师</div>
              <div class="arrow-down">
                <img src="@/assets/image/business/right_arrow.png" alt="箭头">
              </div>
              <div class="process-step">数据系统 交互协同</div>
              <div class="arrow-down">
                <img src="@/assets/image/business/left_arrow.png" alt="箭头">
              </div>
              <div class="process-step">提供高质量法律专业服务</div>
            </div>
            
            <!-- 律师部分 -->
            <div class="entity-box lawyer-box">
              <div class="entity-icon">
                <img src="@/assets/image/business/lawyer_icon.png" alt="律师">
              </div>
              <!-- <div class="entity-name">律师</div> -->
            </div>
          </div>
        </div>
      </section>
      
      <!-- 第四部分：服务流程 -->
      <section class="service-process-section" ref="serviceProcessSection">
        <div class="container">
          <h2 class="section-title animate-scroll">服务流程</h2>
          
          <div class="process-diagram animate-scroll">
            <!-- 连接箭头 -->
            <div class="process-connection">
              <img src="@/assets/image/business/process_path.png" alt="流程连接">
            </div>
            
            <!-- 上半部分流程 -->
            <div class="process-row top-row">
              <div class="process-node">案件接收</div>
              <div class="process-node">材料梳理</div>
              <div class="process-node">目标确认</div>
              <div class="process-node">策略达成</div>
              <div class="process-node">遴选律师</div>
              <div class="process-node">庭前准备</div>
            </div>
            
            <!-- 下半部分流程 -->
            <div class="process-row bottom-row">
              <div class="process-node">结果交付</div>
              <div class="process-node">判决调解</div>
              <div class="process-node">庭后补充</div>
              <div class="process-node">庭后工作</div>
              <div class="process-node">案件开庭</div>
              <div class="process-node">线索调查</div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 第五部分：法律领域 -->
      <section class="legal-fields-section" ref="legalFieldsSection">
        <div class="container">
          <h2 class="section-title animate-scroll">已服务案件覆盖多法律领域</h2>
          
          <div class="legal-fields-container animate-scroll">
            <div v-for="(field, index) in legalFields" :key="index" class="legal-field-item">
              <div class="field-name">{{ field.name }}</div>
              <div class="field-count">{{ field.count }}</div>
            </div>
          </div>
          <div class="legal-fields-container animate-scroll">
            <div v-for="(field, index) in legalFields2" :key="index" class="legal-field-item">
              <div class="field-name">{{ field.name }}</div>
              <div class="field-count">{{ field.count }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="footer-wrapper">
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';

export default {
  name: 'BusinessPage',
  components: {
    AppFooter,
    AppHeader
  },
  data() {
    return {
      observers: [],
      legalFields: [
        { name: '合同纠纷', count: '2366件' },
        { name: '知产纠纷', count: '899件' },
        { name: '侵权纠纷', count: '1711件' },
        { name: '劳争纠纷', count: '522件' },
        { name: '保险纠纷', count: '1030件' },
        { name: '票据纠纷', count: '372件' },
        { name: '不正当竞争纠纷', count: '145件' },
        { name: '金融借贷纠纷', count: '8300件' },
      ],
      legalFields2: [
        { name: '刑事', count: '92件' },
        { name: '仲裁', count: '681件' },
        { name: '执行/恢复执行', count: '425件' },
        { name: '破产', count: '152件' }
      ]
    }
  },
  mounted() {
    this.initScrollAnimations();
    
    // 首屏动画自动播放
    const animateElements = document.querySelectorAll('.animate');
    animateElements.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add('visible');
      }, 300 * index);
    });
    // 头部动画
    this.$nextTick(() => {
      const header = this.$el.querySelector('.logo-area.animate-scroll');
      if (header) header.classList.add('visible');
    });
  },
  beforeUnmount() {
    // 清除所有观察者
    this.observers.forEach(observer => observer.disconnect());
  },
  methods: {
    initScrollAnimations() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      
      const sections = [
        this.$refs.serviceIntroSection,
        this.$refs.serviceStructureSection,
        this.$refs.serviceProcessSection,
        this.$refs.legalFieldsSection
      ];
      
      sections.forEach(section => {
        if (section) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const animatedElements = entry.target.querySelectorAll('.animate-scroll');
                animatedElements.forEach(el => {
                  el.classList.add('visible');
                });
              }
            });
          }, options);
          
          observer.observe(section);
          this.observers.push(observer);
        }
      });
    },
  }
}
</script>

<style scoped>
.business-page {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  background-color: rgba(248, 248, 248, 1);
  width: 1920px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.footer-wrapper {
  flex-shrink: 0;
}

/* 入场动画基础样式 */
.animate, .animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}

.animate.visible, .animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 英雄区域样式 */
.hero-section {
  width: 1920px;
  height: 600px;
  background-image: url('~@/assets/image/business/background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 302px;
  padding-left: 2px;
}

.hero-title {
  font-weight: 600;
  font-size: 40px;
  color: #FFFFFF;
  margin: 0;
  line-height: 56px;
}

.hero-subtitle {
  font-weight: 400;
  font-size: 26px;
  color: #FFFFFF;
  margin-top: 10px;
  line-height: 37px;
}

/* 服务介绍部分 */
.service-intro-section {
  width: 1920px;
  background-color: #FFFFFF;
  padding: 40px 0;
}

.intro-text {
  width: 1196px;
  margin-bottom: 40px;
}

.intro-text p {
  font-size: 26px;
  line-height: 37px;
  color: #333333;
}

.section-title {
  font-size: 36px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 32px;
  line-height: 50px;
}

.advantage-list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
}

.advantage-item {
  width: 380px;
  height: 208px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 37px rgba(242, 242, 242, 1);
  padding: 30px 20px;
  box-sizing: border-box;
}

.advantage-icon img {
  width: 40px;
  height: 40px;
}

.advantage-content {
  margin-top: 11px;
}

.advantage-title {
  font-size: 26px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 10px;
  line-height: 37px;
}

.advantage-desc {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
}

/* 服务结构部分 */
.service-structure-section {
  width: 1920px;
  background-color: rgba(248, 248, 248, 1);
  padding: 40px 0;
  min-height: 452px;
}

.structure-diagram {
  position: relative;
  height: 280px;
  margin-top: 40px;
}

.entity-box {
  /* width: 120px;
  height: 132px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 37px rgba(242, 242, 242, 1); */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.enterprise-box {
  left: 0;
  top: 19px;
}

.lawyer-box {
  right: 0;
  top: 19px;
}

.entity-icon img {
  width: 194px;
  height: 206px;
}

.entity-name {
  font-size: 26px;
  font-weight: 500;
  color: #333333;
  margin-top: 10px;
}

.process-flow {
  width: 224px;
  position: absolute;
  text-align: center;
}

.enterprise-flow {
  left: 178px;
  top: 0;
}

.lawyer-flow {
  right: 178px;
  top: 0;
}

.process-step {
  font-size: 20px;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
}

.process-flow .process-step:nth-child(3) {
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  line-height: 33px;
  margin: 15px 0;
}

.arrow-down {
  margin: 19px auto;
}

.arrow-down img {
  width: 55px;
  height: 6px;
}

.management-team {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80px;
}

.team-icon img {
  width: 284px;
  height: 284px;
}

.team-name {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin-top: 10px;
  white-space: nowrap;
}

/* 服务流程部分 */
.service-process-section {
  width: 1920px;
  background-color: #FFFFFF;
  padding: 40px 0;
  min-height: 310px;
}

.process-diagram {
  /* position: relative;
  margin-top: 40px;
  height: 140px; */
}

.process-connection {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

.process-connection img {
  width: 1071px;
}

.process-row {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin-top: 50px;
}

.top-row {
  bottom: 10px;
  flex-direction: row;
}

.bottom-row {
  top: 0;
  flex-direction: row-reverse;
}

.process-node {
  width: 120px;
  height: 40px;
  background-color: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #333333;
}

/* 法律领域部分 */
.legal-fields-section {
  width: 1920px;
  background-color: #f8f8f8;
  padding: 60px 0;
}

.legal-fields-container {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 15px;
  margin-top: 40px;
  width: 100%;
}

.legal-field-item {
  height: 80px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  padding: 10px;
}

.legal-field-item:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.field-name {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 5px;
  position: relative;
  display: inline-block;
  line-height: 1.2;
}

.field-name::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 8px;
  background: linear-gradient(90deg, rgba(49, 89, 179, 0.8), rgba(49, 89, 179, 0.1));
  z-index: -1;
}

.field-count {
  font-size: 14px;
  color: #3159B3;
  font-weight: 500;
  position: relative;
  z-index: 2;
}

.legal-field-item::after {
  display: none;
}

@media screen and (max-width: 1600px) {
  .legal-fields-container {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media screen and (max-width: 1200px) {
  .legal-fields-container {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media screen and (max-width: 1920px) {
  .business-page, .hero-section, .service-intro-section, .service-structure-section, 
  .service-process-section, .legal-fields-section {
    width: 100%;
  }
}
</style> 